import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleDownload, handleErrors } from '../apiUtils';

export default {
    showScreener: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/show_screener";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    createOrUpdateScreener: async ({ missionId, surveyJson, saveId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/create_or_update_screener";

        const body = JSON.stringify({
            survey: {
                survey_data: surveyJson,
                save_no: saveId,
                survey_type: "screener"
            }
        });


        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },
    showSurvey: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/show_survey";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    createOrUpdateSurvey: async ({ missionId, surveyJson, saveId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/create_or_update_survey";

        const body = JSON.stringify({
            survey: {
                survey_data: surveyJson,
                save_no: saveId,
                survey_type: "survey"
            }
        });


        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    downloadSurvey: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/download_excel_survey_only";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleDownload(response, handleRedirect);
        } catch (error) {
            return handleErrors(error);
        }
    },


    downloadSurveyAndScreener: async ({ missionId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/download_excel_survey_and_screener";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleDownload(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    signAsset: async ({ missionId, is_screener, filename, content_type, size, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/surveys/sign_asset";
        const body = JSON.stringify({
            filename,
            content_type,
            size,
            is_screener

        });
        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }



}